/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkResumeApplicantUserIdsBody } from '../models';
// @ts-ignore
import type { CreateLeaderboardFileResponse } from '../models';
// @ts-ignore
import type { DownloadApplicantResumeBody } from '../models';
// @ts-ignore
import type { DownloadResumeBuilderPdfBody } from '../models';
// @ts-ignore
import type { EmailAttachUploadFileResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FileUploadResponse } from '../models';
// @ts-ignore
import type { GetS3FileParams } from '../models';
// @ts-ignore
import type { GetS3FileResponse } from '../models';
// @ts-ignore
import type { ResumeFileUploadResponse } from '../models';
// @ts-ignore
import type { UploadImageFileResponse } from '../models';
/**
 * FilesApiApi - axios parameter creator
 */
export const FilesApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkResumeApplicantUserIdsBody} bulkResumeApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiBulkDownloadResume: async (jobId: string, orgId: string, bulkResumeApplicantUserIdsBody: BulkResumeApplicantUserIdsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('filesApiBulkDownloadResume', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('filesApiBulkDownloadResume', 'orgId', orgId)
            // verify required parameter 'bulkResumeApplicantUserIdsBody' is not null or undefined
            assertParamExists('filesApiBulkDownloadResume', 'bulkResumeApplicantUserIdsBody', bulkResumeApplicantUserIdsBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/resume/bulk`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkResumeApplicantUserIdsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competition] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [skillId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiCreateLeaderboardFile: async (competition?: string, page?: number, pageSize?: number, skillId?: string, timePeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/create-leaderboard-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competition !== undefined) {
                localVarQueryParameter['competition'] = competition;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['time_period'] = timePeriod;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [fileUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadFile: async (fileUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/get-s3-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileUrl !== undefined) {
                localVarQueryParameter['file_url'] = fileUrl;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadFileFromPath: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/download-file-from-path`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadPublicCertificate: async (certificateAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateAlias' is not null or undefined
            assertParamExists('filesApiDownloadPublicCertificate', 'certificateAlias', certificateAlias)
            const localVarPath = `/public/certificate/{certificate_alias}/download`
                .replace('{certificate_alias}', encodeURIComponent(String(certificateAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadPublicUserResume: async (resumeAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeAlias' is not null or undefined
            assertParamExists('filesApiDownloadPublicUserResume', 'resumeAlias', resumeAlias)
            const localVarPath = `/public/resume/{resume_alias}`
                .replace('{resume_alias}', encodeURIComponent(String(resumeAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DownloadResumeBuilderPdfBody} downloadResumeBuilderPdfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadResumeBuilderPdf: async (downloadResumeBuilderPdfBody: DownloadResumeBuilderPdfBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadResumeBuilderPdfBody' is not null or undefined
            assertParamExists('filesApiDownloadResumeBuilderPdf', 'downloadResumeBuilderPdfBody', downloadResumeBuilderPdfBody)
            const localVarPath = `/files/resume-builder-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadResumeBuilderPdfBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dateMax] 
         * @param {string} [dateMin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetAllInvoiceInZip: async (dateMax?: string, dateMin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/get-invoice-zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateMax !== undefined) {
                localVarQueryParameter['date_max'] = dateMax;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['date_min'] = dateMin;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {DownloadApplicantResumeBody} downloadApplicantResumeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetApplicantResume: async (applicantId: string, jobId: string, orgId: string, downloadApplicantResumeBody: DownloadApplicantResumeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('filesApiGetApplicantResume', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('filesApiGetApplicantResume', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('filesApiGetApplicantResume', 'orgId', orgId)
            // verify required parameter 'downloadApplicantResumeBody' is not null or undefined
            assertParamExists('filesApiGetApplicantResume', 'downloadApplicantResumeBody', downloadApplicantResumeBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/resume-pdf`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadApplicantResumeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetJobApplicantResume: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('filesApiGetJobApplicantResume', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/applicant-resume`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetResumeResearchReport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/download-resume-research-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetUploadedResumeFile: async (userResumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('filesApiGetUploadedResumeFile', 'userResumeId', userResumeId)
            const localVarPath = `/files/user-resume/{user_resume_id}`
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadAttachmentToBucket: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadAttachmentToBucket', 'file', file)
            const localVarPath = `/files/upload-email-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadCertificationImage: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadCertificationImage', 'file', file)
            const localVarPath = `/files/upload-certification-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {boolean} [compress] 
         * @param {string} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadImage: async (imageFile: File, compress?: boolean, questionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('filesApiUploadImage', 'imageFile', imageFile)
            const localVarPath = `/files/upload-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (compress !== undefined) {
                localVarQueryParameter['compress'] = compress;
            }


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }

            if (questionId !== undefined) { 
                localVarFormParams.append('question_id', questionId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadJobChatAttachment: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadJobChatAttachment', 'file', file)
            const localVarPath = `/files/upload-job-chat-attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadMailBodyImg: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadMailBodyImg', 'file', file)
            const localVarPath = `/upload/mail-body-img`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadOfferLetter: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadOfferLetter', 'file', file)
            const localVarPath = `/files/upload-offer-letter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {File} orgDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadOrgDocument: async (orgId: string, orgDocument: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('filesApiUploadOrgDocument', 'orgId', orgId)
            // verify required parameter 'orgDocument' is not null or undefined
            assertParamExists('filesApiUploadOrgDocument', 'orgDocument', orgDocument)
            const localVarPath = `/files/upload-org-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }


            if (orgDocument !== undefined) { 
                localVarFormParams.append('org_document', orgDocument as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadProjectImage: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadProjectImage', 'file', file)
            const localVarPath = `/files/upload-project-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} resumeFile 
         * @param {boolean | null} [setAsDefault] 
         * @param {boolean | null} [fastParse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadResume: async (resumeFile: File, setAsDefault?: boolean | null, fastParse?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeFile' is not null or undefined
            assertParamExists('filesApiUploadResume', 'resumeFile', resumeFile)
            const localVarPath = `/files/upload-resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (setAsDefault !== undefined) { 
                localVarFormParams.append('set_as_default', String(setAsDefault) as any);
            }

            if (resumeFile !== undefined) { 
                localVarFormParams.append('resume_file', resumeFile as any);
            }

            if (fastParse !== undefined) { 
                localVarFormParams.append('fast_parse', String(fastParse) as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadVerificationReport: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('filesApiUploadVerificationReport', 'file', file)
            const localVarPath = `/files/upload-verification-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApiApi - functional programming interface
 */
export const FilesApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkResumeApplicantUserIdsBody} bulkResumeApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiBulkDownloadResume(jobId: string, orgId: string, bulkResumeApplicantUserIdsBody: BulkResumeApplicantUserIdsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiBulkDownloadResume(jobId, orgId, bulkResumeApplicantUserIdsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiBulkDownloadResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competition] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [skillId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiCreateLeaderboardFile(competition?: string, page?: number, pageSize?: number, skillId?: string, timePeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLeaderboardFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiCreateLeaderboardFile(competition, page, pageSize, skillId, timePeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiCreateLeaderboardFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [fileUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiDownloadFile(fileUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetS3FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiDownloadFile(fileUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiDownloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiDownloadFileFromPath(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiDownloadFileFromPath(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiDownloadFileFromPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiDownloadPublicCertificate(certificateAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiDownloadPublicCertificate(certificateAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiDownloadPublicCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiDownloadPublicUserResume(resumeAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiDownloadPublicUserResume(resumeAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiDownloadPublicUserResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DownloadResumeBuilderPdfBody} downloadResumeBuilderPdfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiDownloadResumeBuilderPdf(downloadResumeBuilderPdfBody: DownloadResumeBuilderPdfBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiDownloadResumeBuilderPdf(downloadResumeBuilderPdfBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiDownloadResumeBuilderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dateMax] 
         * @param {string} [dateMin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiGetAllInvoiceInZip(dateMax?: string, dateMin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiGetAllInvoiceInZip(dateMax, dateMin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiGetAllInvoiceInZip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {DownloadApplicantResumeBody} downloadApplicantResumeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiGetApplicantResume(applicantId: string, jobId: string, orgId: string, downloadApplicantResumeBody: DownloadApplicantResumeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiGetApplicantResume(applicantId, jobId, orgId, downloadApplicantResumeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiGetApplicantResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiGetJobApplicantResume(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiGetJobApplicantResume(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiGetJobApplicantResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiGetResumeResearchReport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetS3FileParams>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiGetResumeResearchReport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiGetResumeResearchReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiGetUploadedResumeFile(userResumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiGetUploadedResumeFile(userResumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiGetUploadedResumeFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadAttachmentToBucket(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAttachUploadFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadAttachmentToBucket(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadAttachmentToBucket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadCertificationImage(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadCertificationImage(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadCertificationImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {boolean} [compress] 
         * @param {string} [questionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadImage(imageFile: File, compress?: boolean, questionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadImage(imageFile, compress, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadJobChatAttachment(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadJobChatAttachment(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadJobChatAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadMailBodyImg(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadMailBodyImg(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadMailBodyImg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadOfferLetter(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadOfferLetter(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadOfferLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {File} orgDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadOrgDocument(orgId: string, orgDocument: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadOrgDocument(orgId, orgDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadOrgDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadProjectImage(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadProjectImage(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadProjectImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} resumeFile 
         * @param {boolean | null} [setAsDefault] 
         * @param {boolean | null} [fastParse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadResume(resumeFile: File, setAsDefault?: boolean | null, fastParse?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeFileUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadResume(resumeFile, setAsDefault, fastParse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesApiUploadVerificationReport(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesApiUploadVerificationReport(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApiApi.filesApiUploadVerificationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesApiApi - factory interface
 */
export const FilesApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FilesApiApiFilesApiBulkDownloadResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiBulkDownloadResume(requestParameters: FilesApiApiFilesApiBulkDownloadResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiBulkDownloadResume(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkResumeApplicantUserIdsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiCreateLeaderboardFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiCreateLeaderboardFile(requestParameters: FilesApiApiFilesApiCreateLeaderboardFileRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateLeaderboardFileResponse> {
            return localVarFp.filesApiCreateLeaderboardFile(requestParameters.competition, requestParameters.page, requestParameters.pageSize, requestParameters.skillId, requestParameters.timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiDownloadFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadFile(requestParameters: FilesApiApiFilesApiDownloadFileRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetS3FileResponse> {
            return localVarFp.filesApiDownloadFile(requestParameters.fileUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadFileFromPath(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiDownloadFileFromPath(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiDownloadPublicCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadPublicCertificate(requestParameters: FilesApiApiFilesApiDownloadPublicCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiDownloadPublicCertificate(requestParameters.certificateAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiDownloadPublicUserResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadPublicUserResume(requestParameters: FilesApiApiFilesApiDownloadPublicUserResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiDownloadPublicUserResume(requestParameters.resumeAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiDownloadResumeBuilderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiDownloadResumeBuilderPdf(requestParameters: FilesApiApiFilesApiDownloadResumeBuilderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiDownloadResumeBuilderPdf(requestParameters.downloadResumeBuilderPdfBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiGetAllInvoiceInZipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetAllInvoiceInZip(requestParameters: FilesApiApiFilesApiGetAllInvoiceInZipRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiGetAllInvoiceInZip(requestParameters.dateMax, requestParameters.dateMin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiGetApplicantResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetApplicantResume(requestParameters: FilesApiApiFilesApiGetApplicantResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiGetApplicantResume(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.downloadApplicantResumeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiGetJobApplicantResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetJobApplicantResume(requestParameters: FilesApiApiFilesApiGetJobApplicantResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiGetJobApplicantResume(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetResumeResearchReport(options?: RawAxiosRequestConfig): AxiosPromise<GetS3FileParams> {
            return localVarFp.filesApiGetResumeResearchReport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiGetUploadedResumeFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiGetUploadedResumeFile(requestParameters: FilesApiApiFilesApiGetUploadedResumeFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesApiGetUploadedResumeFile(requestParameters.userResumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadAttachmentToBucketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadAttachmentToBucket(requestParameters: FilesApiApiFilesApiUploadAttachmentToBucketRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailAttachUploadFileResponse> {
            return localVarFp.filesApiUploadAttachmentToBucket(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadCertificationImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadCertificationImage(requestParameters: FilesApiApiFilesApiUploadCertificationImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadCertificationImage(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadImage(requestParameters: FilesApiApiFilesApiUploadImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadImage(requestParameters.imageFile, requestParameters.compress, requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadJobChatAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadJobChatAttachment(requestParameters: FilesApiApiFilesApiUploadJobChatAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadJobChatAttachment(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadMailBodyImgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadMailBodyImg(requestParameters: FilesApiApiFilesApiUploadMailBodyImgRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadMailBodyImg(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadOfferLetterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadOfferLetter(requestParameters: FilesApiApiFilesApiUploadOfferLetterRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadOfferLetter(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadOrgDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadOrgDocument(requestParameters: FilesApiApiFilesApiUploadOrgDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileUploadResponse> {
            return localVarFp.filesApiUploadOrgDocument(requestParameters.orgId, requestParameters.orgDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadProjectImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadProjectImage(requestParameters: FilesApiApiFilesApiUploadProjectImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadProjectImage(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadResume(requestParameters: FilesApiApiFilesApiUploadResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeFileUploadResponse> {
            return localVarFp.filesApiUploadResume(requestParameters.resumeFile, requestParameters.setAsDefault, requestParameters.fastParse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilesApiApiFilesApiUploadVerificationReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesApiUploadVerificationReport(requestParameters: FilesApiApiFilesApiUploadVerificationReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageFileResponse> {
            return localVarFp.filesApiUploadVerificationReport(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for filesApiBulkDownloadResume operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiBulkDownloadResumeRequest {
    readonly jobId: string

    readonly orgId: string

    readonly bulkResumeApplicantUserIdsBody: BulkResumeApplicantUserIdsBody
}

/**
 * Request parameters for filesApiCreateLeaderboardFile operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiCreateLeaderboardFileRequest {
    readonly competition?: string

    readonly page?: number

    readonly pageSize?: number

    readonly skillId?: string

    readonly timePeriod?: string
}

/**
 * Request parameters for filesApiDownloadFile operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiDownloadFileRequest {
    readonly fileUrl?: string
}

/**
 * Request parameters for filesApiDownloadPublicCertificate operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiDownloadPublicCertificateRequest {
    readonly certificateAlias: string
}

/**
 * Request parameters for filesApiDownloadPublicUserResume operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiDownloadPublicUserResumeRequest {
    readonly resumeAlias: string
}

/**
 * Request parameters for filesApiDownloadResumeBuilderPdf operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiDownloadResumeBuilderPdfRequest {
    readonly downloadResumeBuilderPdfBody: DownloadResumeBuilderPdfBody
}

/**
 * Request parameters for filesApiGetAllInvoiceInZip operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiGetAllInvoiceInZipRequest {
    readonly dateMax?: string

    readonly dateMin?: string
}

/**
 * Request parameters for filesApiGetApplicantResume operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiGetApplicantResumeRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly downloadApplicantResumeBody: DownloadApplicantResumeBody
}

/**
 * Request parameters for filesApiGetJobApplicantResume operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiGetJobApplicantResumeRequest {
    readonly jobId: string
}

/**
 * Request parameters for filesApiGetUploadedResumeFile operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiGetUploadedResumeFileRequest {
    readonly userResumeId: string
}

/**
 * Request parameters for filesApiUploadAttachmentToBucket operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadAttachmentToBucketRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadCertificationImage operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadCertificationImageRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadImage operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadImageRequest {
    readonly imageFile: File

    readonly compress?: boolean

    readonly questionId?: string
}

/**
 * Request parameters for filesApiUploadJobChatAttachment operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadJobChatAttachmentRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadMailBodyImg operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadMailBodyImgRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadOfferLetter operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadOfferLetterRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadOrgDocument operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadOrgDocumentRequest {
    readonly orgId: string

    readonly orgDocument: File
}

/**
 * Request parameters for filesApiUploadProjectImage operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadProjectImageRequest {
    readonly file: File
}

/**
 * Request parameters for filesApiUploadResume operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadResumeRequest {
    readonly resumeFile: File

    readonly setAsDefault?: boolean | null

    readonly fastParse?: boolean | null
}

/**
 * Request parameters for filesApiUploadVerificationReport operation in FilesApiApi.
 */
export interface FilesApiApiFilesApiUploadVerificationReportRequest {
    readonly file: File
}

/**
 * FilesApiApi - object-oriented interface
 */
export class FilesApiApi extends BaseAPI {
    /**
     * 
     * @param {FilesApiApiFilesApiBulkDownloadResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiBulkDownloadResume(requestParameters: FilesApiApiFilesApiBulkDownloadResumeRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiBulkDownloadResume(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkResumeApplicantUserIdsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiCreateLeaderboardFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiCreateLeaderboardFile(requestParameters: FilesApiApiFilesApiCreateLeaderboardFileRequest = {}, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiCreateLeaderboardFile(requestParameters.competition, requestParameters.page, requestParameters.pageSize, requestParameters.skillId, requestParameters.timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiDownloadFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiDownloadFile(requestParameters: FilesApiApiFilesApiDownloadFileRequest = {}, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiDownloadFile(requestParameters.fileUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiDownloadFileFromPath(options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiDownloadFileFromPath(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiDownloadPublicCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiDownloadPublicCertificate(requestParameters: FilesApiApiFilesApiDownloadPublicCertificateRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiDownloadPublicCertificate(requestParameters.certificateAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiDownloadPublicUserResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiDownloadPublicUserResume(requestParameters: FilesApiApiFilesApiDownloadPublicUserResumeRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiDownloadPublicUserResume(requestParameters.resumeAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiDownloadResumeBuilderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiDownloadResumeBuilderPdf(requestParameters: FilesApiApiFilesApiDownloadResumeBuilderPdfRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiDownloadResumeBuilderPdf(requestParameters.downloadResumeBuilderPdfBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiGetAllInvoiceInZipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiGetAllInvoiceInZip(requestParameters: FilesApiApiFilesApiGetAllInvoiceInZipRequest = {}, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiGetAllInvoiceInZip(requestParameters.dateMax, requestParameters.dateMin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiGetApplicantResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiGetApplicantResume(requestParameters: FilesApiApiFilesApiGetApplicantResumeRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiGetApplicantResume(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.downloadApplicantResumeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiGetJobApplicantResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiGetJobApplicantResume(requestParameters: FilesApiApiFilesApiGetJobApplicantResumeRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiGetJobApplicantResume(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiGetResumeResearchReport(options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiGetResumeResearchReport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiGetUploadedResumeFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiGetUploadedResumeFile(requestParameters: FilesApiApiFilesApiGetUploadedResumeFileRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiGetUploadedResumeFile(requestParameters.userResumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadAttachmentToBucketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadAttachmentToBucket(requestParameters: FilesApiApiFilesApiUploadAttachmentToBucketRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadAttachmentToBucket(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadCertificationImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadCertificationImage(requestParameters: FilesApiApiFilesApiUploadCertificationImageRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadCertificationImage(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadImage(requestParameters: FilesApiApiFilesApiUploadImageRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadImage(requestParameters.imageFile, requestParameters.compress, requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadJobChatAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadJobChatAttachment(requestParameters: FilesApiApiFilesApiUploadJobChatAttachmentRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadJobChatAttachment(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadMailBodyImgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadMailBodyImg(requestParameters: FilesApiApiFilesApiUploadMailBodyImgRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadMailBodyImg(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadOfferLetterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadOfferLetter(requestParameters: FilesApiApiFilesApiUploadOfferLetterRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadOfferLetter(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadOrgDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadOrgDocument(requestParameters: FilesApiApiFilesApiUploadOrgDocumentRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadOrgDocument(requestParameters.orgId, requestParameters.orgDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadProjectImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadProjectImage(requestParameters: FilesApiApiFilesApiUploadProjectImageRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadProjectImage(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadResume(requestParameters: FilesApiApiFilesApiUploadResumeRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadResume(requestParameters.resumeFile, requestParameters.setAsDefault, requestParameters.fastParse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilesApiApiFilesApiUploadVerificationReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filesApiUploadVerificationReport(requestParameters: FilesApiApiFilesApiUploadVerificationReportRequest, options?: RawAxiosRequestConfig) {
        return FilesApiApiFp(this.configuration).filesApiUploadVerificationReport(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

